import loanSelectors from '../../../selectors/loan';
const loanSelector = loanSelectors.loanSelector;

export const selectGroupedOffers = ({ offersPage = {} }, { maxOffers = 10 }) => {
    // Extract sorted offers from state
    const { offers: rawOffers = {} } = offersPage;
    const { sortedOffers = [] } = rawOffers;

    // Index offers
    const offers = {};
    let offersCount = 0;
    for (let i = sortedOffers.length - 1; i >= 0; i--) {
        if (offersCount >= maxOffers) {
            i = 0;
            break;
        }

        offersCount++;
        const offer = sortedOffers[i];
        const { amount, duration } = offer;

        // Index by amount
        offers[amount] = offers[amount] || {};

        // Further index by duration
        offers[amount][duration] = offer;
    }

    return offers;
};

/**
 * Select the number of offers for each term
 * @param {*} State
 * @returns { [string]: number }
 */
export const selectTermCounts = ({ offersPage = {} }) => {
    // Extract sorted offers from state
    const { offers = {} } = offersPage;
    const { sortedOffers = [] } = offers;

    return sortedOffers.reduce((termCounts, offer) => {
        const { duration } = offer;

        if (termCounts[duration]) {
            termCounts[duration] += 1;
        } else {
            termCounts[duration] = 1;
        }

        return termCounts;
    }, {});
};

/**
 * Select offers for a specific amount
 * @param {*} state 
 * @param {*} param1 
 * @returns {Array} Array of offers for the specified amount
 */
export const selectOffersForAmount = ({ offersPage = {} }, { amount }) => {
    // Extract sorted offers from state
    const { offers = {} } = offersPage;
    const { sortedOffers = [] } = offers;

    // Filter offers by the specified amount
    return sortedOffers.filter(offer => offer.amount === amount);
};

/**
 * Select the selected term for a specific amount
 * @param {*} state 
 * @param {*} param1 
 * @returns {number|null} Selected term for the amount, or null if none selected
 */
export const selectSelectedTermForAmount = (state, { amount }) => {
    const { offersPage = {} } = state;
    const { selectedTermsByAmount = {} } = offersPage;
    const selectedTerm = selectedTermsByAmount[amount];
    
    // First priority: Check if term is already selected in Redux state
    if (selectedTerm) {
        return selectedTerm;
    }

    // Second priority: Check for selectedOffer.duration if amount matches (authenticated offers page)
    const selectedOffer = loanSelector.getSelectedOffer(state) || {};
    if (selectedOffer.duration && selectedOffer.amount === amount) {
        return selectedOffer.duration;
    }
    
    // Third priority: Default to the highest duration for this amount
    const offersForAmount = selectOffersForAmount({ offersPage }, { amount });
    if (offersForAmount.length > 0) {
        const sortedByDuration = [...offersForAmount].sort((a, b) => b.duration - a.duration);
        return sortedByDuration[0].duration;
    }
    
    return null;
};

export default {
    selectGroupedOffers,
    selectTermCounts,
    selectOffersForAmount,
    selectSelectedTermForAmount,
};
